import styles from '../../index.module.scss'
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import Utils from '@utils/utils'
import { TYPETITLEMAP, IMAGE_TYPE, RESOLUTION_ALIGN } from '@utils/CONST'

const ModelLeftCom = (props) => {
    const { item, selectedInputImg, setSelectedInputImg } = props

    const title = (
        <>
            <p className={styles.title}>{item?.projectName}</p>
            <p>{item?.projectType == 'tryonBatch' ? 'AI试衣' : item?.projectType == 'changeModelBatch' ? '换模特' : '换背景'}</p>
            <p>{item?.createdTime}</p>
        </>
    )
    const mode = (
        <p style={{ marginBottom: '24px' }}>{item?.attr?.mode == 'std' ? '标准模式' : '高品质模式'}</p>
    )
    const skinRefine = (
        <p>已开启人像皮肤优化</p>
    )
    const inputImg = (
        <>
            <p>{item?.projectType == 'tryonBatch' ? '商品图' : '模特图'}</p>
            <div className={styles.inputImg}>
                <img src={Utils.getImgThumbnail(item?.inputImages?.filter((i) => i.mainImage)?.[0]?.url)} alt="" />
            </div>
        </>
    )
    const resolutionAlign = (
        <>
            <p>{item?.resolutionAlign == RESOLUTION_ALIGN.INPUT ? '按输入图比例生成' : '按参考图比例生成'}</p>
        </>
    )
    const poseImg = (
        <>
            <p>姿势参考图</p>
            <img src={Utils.getImgThumbnail(item?.attr?.pose?.url)} alt="" />
        </>
    )
    const modelImg = (
        item?.attr?.person?.url && <>
            <p>模特参考图</p>
            {!item?.keepPose && <img src={Utils.getImgThumbnail(item?.attr?.person?.url)} alt="" />}
        </>
    )

    const bkgImg = (
        item?.attr?.background?.url && <>
            <p>背景参考图</p>
            {!item?.keepPose && <img src={Utils.getImgThumbnail(item?.attr?.background?.url)} alt="" />}
        </>
    )
    const matchImg = (
        item?.inputImages?.filter((i) => !i.mainImage)?.[0]?.url && <>
            <p>搭配参考图</p>
            <div className={styles.inputImg}>
                <img src={Utils.getImgThumbnail(item?.inputImages?.filter((i) => !i.mainImage)?.[0]?.url)} alt="" />
            </div>
        </>
    )

    const showConent = (
        item?.projectType == 'tryonBatch' ? (
            <>
                {title}
                {mode}
                {inputImg}
                {poseImg}
                {modelImg}
                {matchImg}
            </>
        ) : item?.projectType == 'changeModelBatch' ?
            (
                <>
                    {title}
                    {item?.attr?.skinRefine ? skinRefine : null}
                    {inputImg}
                    {modelImg}
                </>
            ) : item?.projectType == 'changeBkgBatch' ?
                (
                    <>
                        {title}
                        {item?.attr?.skinRefine ? skinRefine : null}
                        {resolutionAlign}
                        {inputImg}
                        {bkgImg}
                    </>
                ) : null
    )


    return (
        <div className={`${styles.ModelLeftCom} _beauty_scrollbar`}>
            {showConent}
        </div>
    )
}

export default ModelLeftCom